import { useState, useContext } from "react";
import styles from "./style.module.css";
import { ThemeContext } from "../../../../ThemeContext";
import ThemeDayWhiteIcon from "../../../../assets/SVG/ThemeDayWhiteIcon";
import ThemeDayGrayIcon from "../../../../assets/SVG/ThemeDayGrayIcon";
import ThemeNightDarkIcon from "../../../../assets/SVG/ThemeNightDarkIcon";
import ThemeNightWhiteIcon from "../../../../assets/SVG/ThemeNightWhiteIcon";

export default function ThemeSwitcher() {

    const {theme, toggleTheme} = useContext(ThemeContext);

    return (
        <div
            className={`${styles.switch} ${
                theme === "night" ? styles.dark : styles.light
            }`}
        >
            <div
                className={styles.thumb}
                style={{
                    transform:
                        theme === "day"
                            ? "translateX(0)"
                            : "translateX(50px)",
                }}
            />
            <button
                className={styles.button}
                onClick={() => toggleTheme()}
            >
                {
                    theme === "day" ?
                        <ThemeDayWhiteIcon /> :
                        <ThemeDayGrayIcon/>
                }
            </button>
            <button
                className={styles.button}
                onClick={() => toggleTheme()}
            >
                {
                    theme === "day" ?
                        <ThemeNightDarkIcon /> :
                        <ThemeNightWhiteIcon />
                }
            </button>
        </div>
    );
}

